import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { EditBoardStructureDialogComponent } from './components/edit-board-structure-dialog/edit-board-structure-dialog.component';
import { UiKitModule } from '../ui-kit/ui-kit.module';
import { TranslationsModule } from '../translations/translations.module';
import { UtilsModule } from '../utils/utils.module';



@NgModule({
  declarations: [
    EditBoardStructureDialogComponent
  ],
  imports: [
    CommonModule,
    HttpClientModule,
    UiKitModule,
    TranslationsModule,
    UtilsModule
  ]
})
export class BoardStructureModule { }
